import React, { useEffect, useState, useContext, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import "../../Styles/Tables/DemoTable.css";
import { CarMakerDemoColumns, CarMakerDemoRows } from "../../Data_Sets/Demo Data Sets/CarMakerDemoDataSet.js";
import { RailOperatorDemoColumns, RailOperatorDemoRows } from "../../Data_Sets/Demo Data Sets/RailOperatorDemoDataSet.js";
import { AirlineDemoColumns, AirlineDemoRows } from "../../Data_Sets/Demo Data Sets/AirlineDemoDataSet.js";
import { RetailDemoColumns, RetailDemoRows } from "../../Data_Sets/Demo Data Sets/RetailDemoDataSet.js";
import { FinanceDemoColumns, FinanceDemoRows } from "../../Data_Sets/Demo Data Sets/FinanceDemoDataSet.js";
import { DetermineWhichCellsToHighlight } from '../../Utils/DetermineWhichCellsToHighlight.js';
import { AppContext } from '../../Utils/Context.js';

const DemoTable = () => {
  const [activeColumns, setActiveColumns] = useState(CarMakerDemoColumns);
  const [activeRows, setActiveRows] = useState(CarMakerDemoRows);
  const { activeDataChip, subscribedTopicString, setColumnData } = useContext(AppContext);

  useEffect(() => {
    if (activeDataChip === "car_maker") {
      setActiveColumns(CarMakerDemoColumns);
      setActiveRows(CarMakerDemoRows);
    } 
    if (activeDataChip === "rail_operator") {
      setActiveColumns(RailOperatorDemoColumns);
      setActiveRows(RailOperatorDemoRows);
    } 
    if (activeDataChip === "airline") {
      setActiveColumns(AirlineDemoColumns);
      setActiveRows(AirlineDemoRows);
    } 
    if (activeDataChip === "retail") {
      setActiveColumns(RetailDemoColumns);
      setActiveRows(RetailDemoRows);
    } 
    if (activeDataChip === "finance") {
      setActiveColumns(FinanceDemoColumns);
      setActiveRows(FinanceDemoRows);
    } 
  }, [activeDataChip]);

  const memoizedData = useMemo(() => {
    return activeColumns.map(column => {
      const columnKey = column.field;
      const availableItems = activeRows
        .map(row => row[columnKey])
        .filter(item => item !== undefined && item !== "");

      return { columnKey, columnData: availableItems };
    });
  }, [activeColumns, activeRows]);

  useEffect(() => {
    setColumnData(memoizedData);
  }, [memoizedData, setColumnData]);

 //==========highlight cells==============
  const getCellClassName = (params) => {
    if(params.value){
      return DetermineWhichCellsToHighlight(subscribedTopicString, memoizedData, params);
    }
  };

  const customDemoColumns = activeColumns.map((column, index) => ({
    ...column,
    cellClassName: (params)=>{
      return getCellClassName({...params, columnIndex: index})
    },
  }));
  //======================================

  return (
    <div className='demo-table-container' >
      <DataGrid rows={activeRows} columns={customDemoColumns} sx={{fontFamily: 'Arial'}}/>
    </div>
  );
}

export default DemoTable;
